/* ================= PLAN SIGNATURES ================= */
export const PLAN_SIGNATURES = {
  trial: [1, 2, 3, 4, 5, 7, 9, 10, 12, 13, 15, 16, 17, 18, 19, 20],
  standard: [1, 4, 6, 8, 11, 14, 18, 19],
  growth: [1, 2, 3, 4, 5, 7, 9, 10, 12, 13, 15, 19, 20],
  pro: [1, 2, 3, 4, 5, 7, 9, 10, 12, 13, 15, 16, 17, 19, 20],
};
